<template>
  <div>
    <ul class="formRegister">
      <li v-for="(item,index) in info" :class="{'codelis':index==1?true:false}"><span class="must">* </span> <span class="formName">{{item.name}}</span><input
        type="text" :placeholder="item.place"><button v-if="index==1" @click="getCode">{{code}}</button></li>

    </ul>
    <button id="submit_btn"><span>确定</span></button>

  </div>
</template>
<script>
  export default {
    data() {
      return {
        code:"获取验证码",
        info: [
          {name:"手机号",place:'手机号'},
          {name:"验证码",place:'请输入验证码'},
          {name:"新密码",place:'请输入密码'},
          {name:"确认密码",place:'请再次确认密码'},
        ],

      }
    },
    props: {},
    methods: {
      getCode(){
        let num = 59;
        this.code = num+'s后重发';
        let obtn = document.getElementById('code');
        obtn.disabled = true;
        obtn.style.background = '#999999';
        obtn.style.color = '#FFFFFF';


        let code =  setInterval(()=>{
          num--;
          this.code = num+'s后重发';
          if(num<1){
            document.getElementById('code').style.disabled = false;
            this.code = '获取验证码';
            clearInterval(code)
          }
        },1000)

      },
    },
    computed: {},
    mounted() {
      document.title = '找回密码'
    }
  }
</script>
<style scoped lang="scss">
  .formRegister{
    font-size: 0.32rem;
    padding: 0.69rem 0.75rem 0rem 0.55rem;
    li{
      margin-bottom: 0.2rem;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      input{
        width:4.6rem;
        height:0.8rem;
        background:rgba(255,255,255,1);
        border:1px solid rgba(204,204,204,1);
        border-radius:10px;
        font-size: 0.28rem;
        padding: 0 0.19rem;
        box-sizing: border-box;
      }
      input::placeholder{
        font-size: 0.28rem;
        color: #999999;
      }

    }
  }
  .must{
    color: #FF0000;
    font-size: 0.28rem;
  }
  .formName{
    display: inline-block;
    width: 1.17rem;
    text-align: justify;
    text-align-last:justify;
    text-justify:distribute-all-lines;
    margin-right: 0.24rem;
    white-space:nowrap;
    color: #666666;
  }
  #submit_btn{
    width:6rem;
    height:0.9rem;
    background:linear-gradient(0deg,rgba(2,130,255,1) 0%,rgba(32,174,255,1) 100%);
    border-radius:10px;
    font-size:0.36rem;
    font-weight:500;
    color:rgba(255,255,255,1);
    margin: 0.99rem auto 0px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
  }
  .codelis{
    input{
      width: 2.6rem !important;
    }
    button{
      display: inline-block;
      outline: none;
      width:1.8rem;
      height:0.8rem;
      background:rgba(255,255,255,1);
      border:1px solid #CCCCCC;
      border-radius:10px;
      color: #999999;
      font-size: 0.26rem;
      margin-left: 0.2rem;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/login/findpass.vue